export const CARD_CONTAINER_MIN_HEIGHT = '167px'

export default {
  CARD_CONTAINER_MIN_HEIGHT,
}
